import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { ApiResponseInterceptor } from './core/interceptors/api-response.interceptor';
import { EncryptionInterceptor } from './core/interceptors/encryption.interceptor';
import { EncryptionSessionService } from './core/services/encryption-session.service';

import { AppHeaderComponent } from './shared/layout/app-header/app-header.component';
import { AppFooterComponent } from './shared/layout/app-footer/footer.component';
import { SpinnerModule } from './shared/components/spinner/spinner.module';
import { AppPopupComponent } from './shared/components/app-popup/app-popup.component';

import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TxShowPassPreset } from '../themes';

@NgModule({
  declarations: [
    AppComponent,
    AppFooterComponent,
    AppPopupComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    ToastModule,
    DialogModule,
    ButtonModule,
    SpinnerModule,
    AppHeaderComponent,
    RouterModule.forRoot(routes)
  ],
  providers: [
    // Eager, not async: an overlay opened on first render (the NPS drawer) would
    // otherwise stall off-screen while the lazy animation chunk loads.
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: TxShowPassPreset,
        options: {
          darkModeSelector: false || 'none',
          // Layered PrimeNG loses to any unlayered app CSS, so overrides need no `!important`.
          cssLayer: { name: 'primeng', order: 'tailwind-base, primeng, tailwind-utilities' }
        },
      },
    }),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: ApiResponseInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true },
    provideAppInitializer(() => inject(EncryptionSessionService).initialize()),
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}